import { Tab, Tabs, Typography } from '@material-ui/core';
import useStyles from './styles';
import React, { ChangeEvent } from 'react';
import OrderDetailCard from '../OrderDetailCard';
import { Trans } from 'react-i18next';
import { useOrdersState } from '../../context/orders';
import { DrawerType, useInsideDrawerState } from '@src/shared/context/inside-drawer';

const OrderDetailTabs = () => {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const { ordersById, clickedOrderId } = useOrdersState();  
  const {activeDrawerState} = useInsideDrawerState();
  const handleTabsChange = (_: ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };


  return (
    <div className={classes.orderDetailTabsWrapper}>
      <Tabs
        value={value}
        onChange={handleTabsChange}
        indicatorColor="primary"
        textColor="inherit"
        variant="fullWidth"
        scrollButtons="off"
        className={classes.orderDetailIndicator}
      >
        <Tab
          label={
            <Typography
              variant="body1"
              className="body_regular_bold"
              align="left"
            >
              <Trans i18nKey="sidecard.orderDetailTitle" />
            </Typography>
          }
        />
        <Tab disabled />
      </Tabs>
      <div hidden={value !== 0}>
        {activeDrawerState === DrawerType.ORDER_CARD ? <OrderDetailCard {...ordersById[clickedOrderId]}  />  : null }
      </div>
    </div>
  );
};

export default OrderDetailTabs;
